import template from './product-images.template.html';
import './product-images.scss';

export default {
  template,
  bindings: {
    images: '<',
    onClickImage: '&',
    activeImage: '<',
  },
};



// WEBPACK FOOTER //
// ./src/app/product/product-images/product-images.component.js